import { render, staticRenderFns } from "./UserWizardRoles.vue?vue&type=template&id=564575d9&"
import script from "./UserWizardRoles.vue?vue&type=script&lang=js&"
export * from "./UserWizardRoles.vue?vue&type=script&lang=js&"
import style0 from "./UserWizardRoles.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports